import { render } from "./RecycleHistory.vue?vue&type=template&id=06800c5a&scoped=true"
import script from "./RecycleHistory.vue?vue&type=script&lang=ts"
export * from "./RecycleHistory.vue?vue&type=script&lang=ts"

import "./RecycleHistory.vue?vue&type=style&index=0&id=06800c5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06800c5a"

export default script